export const OUTREACH_PAGINATION = {
    DEFAULT_PAGE: 1,
    LIMIT: 20,
};
export const OUTREACH_TABS = [
    { label: "Active", value: "active" },
    { label: "Archived", value: "archived" },
    { label: "Terminated", value: "terminated" },
];
export const STATUS_OPTIONS = [
    { value: "pending_keywords", label: "Pending Keywords" },
    { value: "pending_pitch", label: "Pending Pitch" },
    { value: "pending_contact_info", label: "Pending Contact Info" },
    { value: "pending_os", label: "Pending OS" },
    { value: "pending_client_approval", label: "Pending Client Approval" },
    { value: "pending_am_approval", label: "Pending AM Approval" },
    { value: "in_progress", label: "In Progress" },
    { value: "completed", label: "Completed" },
    { value: "pm_sent", label: "PM Sent" },
    { value: "client_terminated", label: "Client Terminated" },
];
export const TYPE_OPTIONS = [
    { value: "publisher", label: "Publisher" },
    { value: "social", label: "Social" },
    { value: "youtube", label: "YouTube" },
    { value: "linkedin", label: "LinkedIn" },
    { value: "competitor", label: "Competitor" },
    { value: "podcast", label: "Podcast" },
    { value: "unenrolled_bounced", label: "Unenrolled + Bounced" },
];
export const DRAWER_TYPE_OPTIONS = [
    { value: "publisher", label: "Publisher" },
    { value: "social", label: "Social" },
    { value: "youtube", label: "YouTube" },
    { value: "linkedin", label: "LinkedIn" },
    { value: "competitor", label: "Competitor" },
    { value: "podcast", label: "Podcast" },
    { value: "unenrolled_bounced", label: "Unenrolled + Bounced" },
];
export const STATUS_CHIP = {
    pending_keywords: 1,
    pending_pitch: 1,
    pending_contact_info: 1,
    pending_os: 1,
    pending_client_approval: 1,
    pending_am_approval: 1,
    in_progress: 3,
    completed: 2,
    pm_sent: 4,
    client_terminated: 0,
};
